export default {
  isOptionElectrikKit: () => type => {
    return type === 'electric_kit';
  },

  isOptionElectrikDrive: () => type => {
    return type === 'electric_drive';
  },

  isOptionElectricDriveType: () => type => {
    return type === 'electric_drive_type';
  },

  isOptionTube: () => type => {
    return type === 'tube_diameter';
  },

  isOptionDlupr: () => code_1c => {
    return code_1c === 'Длупр';
  },

  getOptionsListText(state) {
    const options = state.optionsList;

    if (options) {
      return options.filter(item => item.field_type === 'T');
    }

    return [];
  },

  getOptionDlupr(state, getters) {
    const options = state.optionsList || [];
    const find = options?.find(item => getters.isOptionDlupr(item.code_1c));

    return find;
  },

  // получаем инфу о том что был ли выбран комплект электрики
  getIsOptionElectrikKitSelected(_, getters) {
    const optionElectrikKit = getters.getOptionElectrikKit;

    if (optionElectrikKit) {
      const optionDefault = optionElectrikKit.option_default;
      const values = optionElectrikKit.options_values || [];

      const valueFind = values.find(item => item.id === optionDefault);

      if (!valueFind) {
        return false;
      }

      return valueFind.name.toLowerCase() !== 'нет';
    }

    return false;
  },

  getOptionElectrikDriveType(state, getters) {
    const options = state.optionsList || [];
    const find = options?.find(item => getters.isOptionElectricDriveType(item.use_type));

    return find;
  },

  getOptionTube(state, getters) {
    const options = state.optionsList || [];
    const find = options?.find(el => getters.isOptionTube(el.use_type));

    return find;
  },

  getOptionElectrikKit(state, getters) {
    const options = state.optionsList || [];
    const find = options?.find(el => getters.isOptionElectrikKit(el.use_type));

    return find;
  },

  getOptionsList(state, getters) {
    const options = state.optionsList;

    if (options) {
      const electric_kit = options.find(el => getters.isOptionElectrikKit(el.use_type));

      return options.filter(item => {
        if (item.code_1c !== 'ТипМансардногоОкна') {
          return true;
        }

        if (electric_kit) {
          if (getters.isOptionElectrikDrive(item.use_type)) {
            return false;
          } else if (getters.isOptionElectricDriveType(item.use_type)) {
            return false;
          }
        }

        return true;
      });
    }

    return [];
  },

  getOptionType(state, getters) {
    const options = state.optionsList || [];
    const item = options.find(el => el.code_1c === 'ТипМансардногоОкна');
    return item;
  },

  getOptionTypeDefaultValue(state, getters) {
    const option = getters.getOptionType;
    let result = null;

    if (option) {
      for (let key in option.options_values) {
        const item = option.options_values[key];

        for (let subKey in item) {
          const subItem = item[subKey];

          for (let i = 0; i < subItem.length; i++) {
            if (subItem[i].id === option.option_default) {
              result = {
                item: key,
                sub: subKey,
                elem: subItem[i],
              };
              break;
            }
          }
        }
      }
    }

    return result;
  },

  getOptionsListFurniture(state, getters) {
    const options = getters.getOptionsList;
    let result = false;

    if (options.length) {
      options.forEach(el => {
        if (el.is_furniture === 1) {
          result = true;
        }
      });
    }

    return result;
  },

  getOptionNotStandart(state, getters) {
    const options = getters.getOptionsList;
    const option = options.find(el => el.code_1c === 'Нестандарт');

    if (option) {
      const value = option.options_values.find(el => el.id === option.option_default);

      if (value?.name === 'Да') {
        return true;
      }
    }

    return false;
  },

  getOptionsListFilterImages(state, getters) {
    const optionsList = state.optionsList || [];
    const getOptionsList = getters.getOptionsList || [];
    const result = [];
    const list = optionsList
      ? getOptionsList?.filter(item => item.is_furniture !== 1 && item.option_default !== null)
      : [];

    if (list?.length) {
      list.forEach(el => {
        if (Array.isArray(el?.options_values)) {
          const item = el.options_values.find(val => val.image && val.id === el.option_default);

          if (item) {
            result.push(item.image);
          }
        }
      });
    }
    return result;
  },

  //TODO: что-то вроде триггера для обновления картинки, разбираться долго
  getOptionsListValues(state) {
    const optionsList = state.optionsList || [];
    const item = optionsList?.[0];
    if (item && item?.options_values) {
      return {
        list: item?.options_values,
        option_default: item?.option_default,
      };
    }

    return null;
  },

  getOptionsListValuesImage(_, getters) {
    const optionsListValues = getters.getOptionsListValues

    if (Array.isArray(optionsListValues?.list)) {
      const find = optionsListValues?.list?.find(el => el.id === optionsListValues.option_default)
      return find?.image
    }

    return null;
  },
};
